import React from 'react';
import { withTheme } from 'styled-components';

import InputMessage from './InputMessage';

const InputErrorMessage = withTheme(({ children, theme }) => (
  <div data-error="true">
    <InputMessage backgroundColor={theme.errorColor}>{children}</InputMessage>
  </div>
));

export default InputErrorMessage;
